import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
}
